/* tslint:disable */
/* eslint-disable */
/**
 * Admin API
 * Internal Admin API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetInstallationPricing200Response
 */
export interface GetInstallationPricing200Response {
    /**
     * 
     * @type {number}
     * @memberof GetInstallationPricing200Response
     */
    yearly: number;
    /**
     * 
     * @type {number}
     * @memberof GetInstallationPricing200Response
     */
    monthly: number;
}

/**
 * Check if a given object implements the GetInstallationPricing200Response interface.
 */
export function instanceOfGetInstallationPricing200Response(value: object): value is GetInstallationPricing200Response {
    if (!('yearly' in value) || value['yearly'] === undefined) return false;
    if (!('monthly' in value) || value['monthly'] === undefined) return false;
    return true;
}

export function GetInstallationPricing200ResponseFromJSON(json: any): GetInstallationPricing200Response {
    return GetInstallationPricing200ResponseFromJSONTyped(json, false);
}

export function GetInstallationPricing200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetInstallationPricing200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'yearly': json['yearly'],
        'monthly': json['monthly'],
    };
}

export function GetInstallationPricing200ResponseToJSON(json: any): GetInstallationPricing200Response {
    return GetInstallationPricing200ResponseToJSONTyped(json, false);
}

export function GetInstallationPricing200ResponseToJSONTyped(value?: GetInstallationPricing200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'yearly': value['yearly'],
        'monthly': value['monthly'],
    };
}

